export default __webpack_public_path__ + "static/media/icon_mongodb.79b45883.png";